var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.381,
    height: 65.261,
    viewBox: "0 0 65.381 65.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_023-app_store",
    "data-name": "023-app store",
    d: "M47.336,65.734H18.046A15.305,15.305,0,0,1,2.831,52.155L.085,28.056a11.026,11.026,0,0,1,10.9-12.217,2.552,2.552,0,0,1,0,5.1,5.87,5.87,0,0,0-5.832,6.534L7.9,51.577A10.2,10.2,0,0,0,18.046,60.63h29.29a10.2,10.2,0,0,0,10.143-9.053l2.746-24.1a5.87,5.87,0,0,0-5.832-6.534,2.552,2.552,0,0,1,0-5.1A11.026,11.026,0,0,1,65.3,28.056l-2.746,24.1A15.3,15.3,0,0,1,47.336,65.734ZM23.493,24.261V14.818c.513-12.361,18.122-12.352,18.631,0v1.021H31.149a2.552,2.552,0,0,0,0,5.1H44.676a2.552,2.552,0,0,0,2.552-2.552V14.818c-.794-19.134-28.052-19.12-28.839,0v9.443a2.552,2.552,0,1,0,5.1,0Zm1.4,13.271a3.19,3.19,0,1,1-3.19-3.19A3.19,3.19,0,0,1,24.9,37.533Zm7.784-3.19a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,32.681,34.342Zm10.974,0a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,43.655,34.342ZM21.706,45.317a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,21.706,45.317Zm10.974,0a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,32.681,45.317Zm10.974,0a3.19,3.19,0,1,0,3.19,3.19A3.19,3.19,0,0,0,43.655,45.317Z",
    transform: "translate(0 -0.473)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStore);
export default __webpack_public_path__ + "static/media/ic_store.d09ab71f6fa38e511e3c7569bedb437e.svg";
export { ForwardRef as ReactComponent };